import { ref, computed, watch } from 'vue'

// Global reactive state for test album visibility
const showTestAlbums = ref(process.env.NODE_ENV === 'development')

// Initialize from localStorage if available
const initializeFromStorage = () => {
  const stored = localStorage.getItem('test-mode-visibility')
  if (stored !== null) {
    showTestAlbums.value = stored === 'true'
  }
  // Otherwise use environment default
}

// Initialize on module load
initializeFromStorage()

// Watch for changes and persist to localStorage
watch(showTestAlbums, (newValue) => {
  localStorage.setItem('test-mode-visibility', newValue.toString())
}, { immediate: false })

export function useTestMode() {
  const includeTestAlbumsParam = computed(() => showTestAlbums.value ? 'true' : 'false')
  
  const toggleTestAlbumsVisibility = () => {
    showTestAlbums.value = !showTestAlbums.value
    // localStorage persistence is handled by the watcher above
  }
  
  const getTestAlbumCreationDefault = () => {
    return process.env.NODE_ENV === 'development'
  }
  
  return {
    showTestAlbums,
    includeTestAlbumsParam,
    toggleTestAlbumsVisibility,
    getTestAlbumCreationDefault,
    initializeFromStorage
  }
}